import styled from 'styled-components';

const ValueIcon = styled.div`
  text-align: center;
  padding-top: 2em;
  padding-bottom: 2em;
  opacity: 0.6;
`;

export default ValueIcon;



// WEBPACK FOOTER //
// ./src/styled/ValueIcon.js